import { Box, Flex, Text, VStack, HStack, Icon } from '@chakra-ui/react'
import React from 'react'
import {
  FiRefreshCw,
  FiDollarSign,
  FiBatteryCharging,
  FiTrendingUp,
  FiCloud,
  FiBarChart2,
  FiThermometer,
  FiDroplet,
  FiCircle,
} from 'react-icons/fi'
import { getLocationsPercentage } from '../../../../utils/helpers'
import PercentageChange from '../../../reports/pages/components/EnergyReportComponents/PercentageChange'

type RowProps = {
  title: string
  total: number
  prevTotal: number
  currentValue: number
  totalUnit: string
  currentUnit: string
  showAverageHint?: boolean
}

const ValueWithUnit = ({ value, unit }: { value: number | string; unit?: string }) => (
  <HStack spacing={1}>
    <Text fontFamily="Inter" fontWeight={700} fontSize="13px" color="#484848">
      {typeof value === 'number' ? value.toFixed(2) : value}
    </Text>
    {unit && (
      <Text as="span" fontFamily="Inter" fontWeight={400} fontSize="12px" color="#9B9B9B">
        {unit}
      </Text>
    )}
  </HStack>
)

const pickIcon = (title: string) => {
  const k = title.toLowerCase()
  if (k.includes('cost')) return FiDollarSign
  if (k.includes('consumed')) return FiRefreshCw
  if (k.includes('produced')) return FiBatteryCharging
  if (k.includes('income')) return FiTrendingUp
  if (k.includes('footprint')) return FiCloud
  if (k.includes('intensity')) return FiBarChart2
  if (k.includes('temperature')) return FiThermometer
  if (k.includes('humid')) return FiDroplet
  return FiCircle
}

export const SummaryRow = ({
  title,
  total,
  prevTotal,
  currentValue,
  totalUnit,
  currentUnit,
  showAverageHint,
}: RowProps) => {
  const IconCmp = pickIcon(title)

  return (
    <Flex justify="space-between" align="center" py={2.5} px={1} borderRadius="md">
      <HStack spacing={3}>
        <Box
          w="28px"
          h="28px"
          borderRadius="full"
          bg="#F5F6F7"
          display="grid"
          placeItems="center"
        >
          <Icon as={IconCmp} color="#6B7280" boxSize="14px" />
        </Box>
        <Text fontWeight={400} fontSize="14px" color="#484848">
          {title}{' '}
          {showAverageHint && (
            <Text as="span" color="#9B9B9B">
              (Average)
            </Text>
          )}
        </Text>
      </HStack>

      <VStack align="flex-end" spacing={0.5}>
        <ValueWithUnit value={total} unit={totalUnit} />
        <PercentageChange
          iconBoxSize={3}
          percentageFontSize={12}
          percentageChange={getLocationsPercentage(total, prevTotal)}
        />
        <Text fontSize="12px" color="#9B9B9B" mt="2px">
          Current{' '}
          <Text as="span" color="#484848" fontWeight={600}>
            {currentValue?.toFixed(2)}
          </Text>{' '}
          {currentUnit}
        </Text>
      </VStack>
    </Flex>
  )
}
